// Standard library imports
import React, { useEffect, useState } from 'react';

// External library imports
import { toast } from 'react-toastify';
import { get as lodashGet } from 'lodash';
import moment from 'moment';
import { Formik, Form } from 'formik';

// Internal module imports
import { RootBiddingService } from '../../../../../services/BiddingService/Root/BiddingService';
import { useLoader, useUserRole } from '../../../../../hooks';
import DatePicker from '../../../../../components/Inputs/DatePicker/DatePicker';
import allDeviceClasses from '../../../../../styles/AllDevices.module.css';
import Typography from '../../../../../components/Typography/Typography';
import { TextArea } from '../../../../../components/Inputs/Input';
import { CreateNoteValidator } from '../../../../../validations/BiddingService/Bidding';
import { AdminBiddingService } from '../../../../../services/BiddingService/Admin/BiddingService';
import { RootBundleBiddingService } from '../../../../../services/BiddingService/Root/BundleBiddingService';
import { AdminBundleBiddingService } from '../../../../../services/BiddingService/Admin/BundleBiddingService';

export const CreateNote = ({ bid, setOpen, getNotes, bidType }) => {
    const { isRootUser } = useUserRole();
    const service = isRootUser ? (bidType === 'bundle' ? RootBundleBiddingService : RootBiddingService) : bidType === 'bundle' ? AdminBundleBiddingService : AdminBiddingService;
    const [date, setdate] = useState(moment().toDate());
    const [startLoader, stopLoader] = useLoader();

    const handleSubmit = (values) => {
        const payload = {
            date,
            ...values,
        };
        service.CreateNote(bid._id, payload, startLoader, handleSuccess, handleError, stopLoader);
    };

    const handleSuccess = () => {
        setOpen({ status: false });
        getNotes();
        toast.success('Note Created Successfully');
    };

    const handleError = (err) => {
        toast.error(lodashGet(err, ['response', 'data', 'message']));
    };

    return (
        <div>
            <div style={{ width: '30vw' }}>
                <div>
                    <Typography content={'Create Note'} size={16} />
                </div>
                <div>
                    <Formik enableReinitialize initialValues={{ description: '' }} onSubmit={handleSubmit} validationSchema={CreateNoteValidator}>
                        {({ errors, values }) => (
                            <Form>
                                <div className={allDeviceClasses.InputContainer}>
                                    <div className={allDeviceClasses.FieldControl2}>
                                        <label>
                                            Date <span className="required">*</span>
                                        </label>
                                        <div className="modal-date-picker">
                                            <DatePicker date={date} setDate={setdate} />
                                        </div>
                                    </div>
                                </div>
                                <div className={allDeviceClasses.InputContainer}>
                                    <div className={allDeviceClasses.FieldControl2}>
                                        <label>
                                            Desciption <span className="required">*</span>
                                        </label>
                                        <TextArea name={`description`} />
                                    </div>
                                </div>
                                <div className={allDeviceClasses.ButtonContainer}>
                                    <div>
                                        <button type="button" className="btn-secondary" onClick={() => setOpen({ status: false })}>
                                            Cancel
                                        </button>
                                    </div>
                                    <div>
                                        <button type="submit" className="btn-primary">
                                            Submit
                                        </button>
                                    </div>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
            </div>
        </div>
    );
};
